import { DEFAULT_CONFIG as APPKIT_CONFIG } from "@opencast/appkit";

export const COLORS = APPKIT_CONFIG.colors;
